import { Box, InputLabel, useTheme } from '@mui/material';
import CustomInput from 'components/custom-input/custom-input.component';
import FormError from 'components/form-error/form-error.component';
import { useSpreedlyCheckoutSdkIframeField } from '../spreedly-checkout-sdk-form.hooks';
import { spreedlyCheckoutSdkIframeFields } from '../spreedly-checkout-sdk-form.component';

const SpreedlyCheckoutSdkIframeField = ({ name, label, id }) => {
  const theme = useTheme();
  const { error } = useSpreedlyCheckoutSdkIframeField(name);

  return (
    <Box id={id}>
      <CustomInput>
        <InputLabel htmlFor={spreedlyCheckoutSdkIframeFields[name]} required>
          {label}
        </InputLabel>
        <Box
          id={name}
          borderBottom={`1px solid ${theme.palette.grey[500]}`}
          display="flex"
          alignItems="flex-end"
          sx={{
            '& iframe': {
              height: '28px !important',
            },
          }}
        ></Box>
        {error && <FormError aria-live="assertive" errorMessage={error} />}
      </CustomInput>
    </Box>
  );
};
export default SpreedlyCheckoutSdkIframeField;
